"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const faker_1 = __importDefault(require("faker"));
const client_library_1 = require("@seneca/client-library");
const errors_1 = require("./errors");
class ChatbotServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
        this.functionURL = options.functionURL;
    }
    async query(query, accessToken) {
        const options = {
            method: 'POST',
            headers: {
                correlationId: `${new Date().getTime()}::${faker_1.default.random.uuid()}`,
                'Content-Type': 'application/json',
                'access-key': accessToken || ''
            },
            body: JSON.stringify(query)
        };
        const response = await this.requestMaker.fetch(this.functionURL.query, options);
        return response.body;
    }
    async generatePrompts(request) {
        const url = `${this.url}/api/generate-prompts`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async search(request) {
        const url = `${this.url}/api/search`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async explain(request) {
        const url = `${this.url}/api/explain`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400)
            throw new errors_1.InappropriateContentError();
        return response.json;
    }
}
exports.default = ChatbotServiceClient;
//# sourceMappingURL=ChatbotServiceClient.js.map